export const PORTAL_KEY = "energyAssistance";

export const ERR_MSG = {
  "073": "We're experiencing technical difficulties. Please try again later. If the issue persists, please reach out to support.",
  "068" : "Error in placing emergency hold. Please try again or contact support for assistance."
};

export const API_LOAD_STATUS = {
  PENDING: "LOADING",
  FULFILLED: "SUCCEEDED",
  REJECTED: "FAILED",
};

export const TOOLTIP_MSG = {
  MAP_CENTER: {
    DISABLED_BTN: "Deletion is not allowed because one or more selected requests are in 'Emailed' status." 
  }
};

export const INTERACTION_HIST = "File is archived. Please contact the WGL.Customer.eService@washgas.com for assistance";

export const SESSION_EXPIRED = "You have been logged out due to inactivity. Please log in to continue.";

export const LOGOUT_MSG = "You have logged out successfully.";